/**
 *
 * Asynchronously loads the component for BusinessTransactionPage
 *
 */
import { lazyLoad } from "utils";

export const BusinessTransactionPageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.BusinessTransactionPage
);

export const BusinessTransactionsDetailsPageLazy = lazyLoad(
  () => import("./business-transactions-details"),
  (module) => module.BusinessTransactionsDetails
);
